import controller from './alerts-actions.controller';

const template = require('./alerts-actions.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions.component.js